// extracted by mini-css-extract-plugin
module.exports = {"customize-modal":"CustomizeModal_customize-modal__hKBj1"};